const AttendanceComponent = () => import('@/views/hrm/Attendance/AttendanceView')

export default [
    {
        path:'/AttendanceIndex',
        name:'AttendanceComponent',
        component:AttendanceComponent
    }
]